<template>
  <div class="manage-main-box">
    <!-- 侧边菜单 -->
    <SliderActivity :activityInfo="activityInfo">
      <div class="book-imgs" v-if="activityInfo" :style="`background-image: url('${activityInfo.cover}');`"></div>
      <div class="book-info">
        <div v-if="activityInfo" class="book-name">{{activityInfo.name}}</div>
        <div class="book-back-btn" @click="backTech()">{{btnTxt}}</div>
      </div>
    </SliderActivity>
    <!-- 中间部分路由页面 -->
    <div class="activity-school-outer">
      <a-config-provider :locale="locale">
        <router-view></router-view>
      </a-config-provider>
    </div>

  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import SliderActivity from "../../../components/school/SliderActivity.vue"
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
export default {
  name: "activityLayout",
  components: {
    SliderActivity,
  },
  data () {
    return {
      school_code: localStorage.getItem("schoolCode"),
      btnTxt: '< 返回教学活动',
      locale: zhCN,
      activity_id: '',
    }
  },
  computed: {
    ...mapState({
      activityInfo: (state) => state.activityStat.activityInfo,
    }),
  },
  mounted () {
    this.activity_id = this.$route.query.id
    this.getSchoolActivityDetail({ id: this.activity_id })
  },
  methods: {
    ...mapActions(["getSchoolActivityDetail"]),
    backTech () {
      this.$router.push(`/${this.school_code}/school/teach`)
    }
  },

}
</script>

<style lang="less" scoped>
.manage-main-box {
    .book-imgs {
        width: 180px;
        height: 140px;
        background-image: url('https://img0.baidu.com/it/u=285032715,784861620&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1740589200&t=8263ff83e9a601115ffd21f6224ba989');
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
    }
    .book-info {
        padding: 10px 16px;
        background: linear-gradient(0deg, #fbf2e7 0%, #f2ddc0 100%);
        .book-name {
            font-weight: bold;
            font-size: 14px;
            color: #373536;
            line-height: 20px;
            margin-bottom: 8px;
        }
        .book-back-btn {
            height: 28px;
            cursor: pointer;
            background: #a82822;
            border-radius: 14px;
            text-align: center;
            line-height: 28px;
            width: 100%;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
            &:hover {
                background: #9d221c;
            }
        }
    }

    .activity-school-outer {
        padding: 20px 0;
        .activity-school-inside {
            background: #ffffff;
            padding: 20px 25px;
            height: calc(100vh - 100px);
        }
    }
}
</style>